type Price = {
  currency: string,
  price: string|number,
}

type Variant = {
  id: string;
  image: string;
  image_hover: string|null;
  image_two_columns: string|null;
  request_only: boolean;
  price: Price|null;
}

class ProductListTeaser {
  public element: HTMLElement;
  public colors: NodeListOf<HTMLLinkElement> | null;
  public deliveryCountryInput: HTMLInputElement | null;
  public currentTaxRateInput: HTMLInputElement | null;
  public deliveryCountryCurrency: string;
  public currentTaxRate: string;
  public variants: Variant[]

  constructor(el: HTMLElement) {
    this.element = el;
  }

  changeDetails(color: HTMLElement) {
    const teaser = color.closest('.m-product-list-teaser');
    const variant = this.variants.find((variant: any) => variant.id == color.dataset.variantId)

    if (!variant) return

    let image = variant?.image;
    // @ts-ignore
    const price = variant[`price-${this.deliveryCountryCurrency.toLowerCase()}`][`${this.currentTaxRate}`].price;
    // @ts-ignore
    const currency = variant[`price-${this.deliveryCountryCurrency.toLowerCase()}`][`${this.currentTaxRate}`].currency;

    if (image) {
      let imageWrapper = teaser?.querySelector('.m-product-list-teaser__image-no-hover--wide') as HTMLElement | null;

      if (imageWrapper) {
        // @ts-ignore
        image = variant.image_two_columns;
      } else {
        imageWrapper = teaser?.querySelector('.m-product-list-teaser__image-no-hover') as HTMLElement | null;
      }

      if (imageWrapper) {
        imageWrapper.style.opacity = '0';
        setTimeout(() => {
          if (imageWrapper) {
            imageWrapper.style.backgroundImage = `url(${image})`;
            imageWrapper.style.opacity = '1';
          }
        }, 250);
      }
    }

    const wishlistIcon = teaser?.querySelector('.js-product-teaser-wishlist-button') as HTMLElement | null;

    if (color.previousElementSibling === null) {
      if (wishlistIcon?.dataset.action === 'remove') {
        wishlistIcon?.classList.add('is-active');
      } else {
        wishlistIcon?.classList.remove('is-active');
      }
    } else {
      if (color.dataset.isOnWishlist == '1') {
        wishlistIcon?.classList.add('is-active');
      } else {
        wishlistIcon?.classList.remove('is-active');
      }
    }

    const priceWrapper = teaser?.querySelector('.m-product-list-teaser__price span:first-child') as HTMLElement | null;

    if (priceWrapper) {
      priceWrapper.dataset.currency = currency;
      priceWrapper.dataset.currentPrice = priceWrapper.dataset.price;
      priceWrapper.textContent = `${color.dataset.showPriceFromText} ${currency} ${price}`;

      if (variant.request_only) {
        priceWrapper.classList.add('hide-price');
      } else {
        priceWrapper.classList.remove('hide-price');
      }
    }
  }

  resetDetails(color: HTMLElement | null) {
    let teaser;

    if (!color) {
      teaser = this.element;
    } else {
      teaser = color.closest('.m-product-list-teaser');
    }

    let imageWrapper = teaser?.querySelector('.m-product-list-teaser__image-no-hover--wide') as HTMLElement | null;
    if (!imageWrapper) {
      imageWrapper = teaser?.querySelector('.m-product-list-teaser__image-no-hover') as HTMLElement | null;
    }

    if (imageWrapper) {
      imageWrapper.style.opacity = '0';
      setTimeout(() => {
        if (imageWrapper) {
          imageWrapper.style.backgroundImage = `url(${imageWrapper.dataset.currentSrc})`;
          imageWrapper.style.opacity = '1';
        }
      }, 250);
    }

    const wishlistIcon = teaser?.querySelector('.js-product-teaser-wishlist-button') as HTMLElement | null;

    if (wishlistIcon?.dataset.action === 'remove') {
      wishlistIcon?.classList.add('is-active');
    } else {
      wishlistIcon?.classList.remove('is-active');
    }

    const priceWrapper = teaser?.querySelector('.m-product-list-teaser__price span:first-child') as HTMLElement | null;

    if (priceWrapper) {
      priceWrapper.textContent = `${priceWrapper.dataset.priceText} ${priceWrapper.dataset.currency} ${priceWrapper.dataset.currentPrice}`;

      if (priceWrapper.dataset.currentPrice) {
        priceWrapper.classList.remove('hide-price');
      } else {
        priceWrapper.classList.add('hide-price');
      }
    }
  }

  initPrice() {
    const priceWrapper = this.element.querySelector('.m-product-list-teaser__price span:first-child') as HTMLElement | null;
    const vatWrapper = this.element.querySelector('.m-product-list-teaser__price span.m-product-list-teaser__vat') as HTMLElement | null;

    const price = priceWrapper?.dataset[`price${this.deliveryCountryCurrency.toLowerCase()}-${this.currentTaxRate.split('.')[this.currentTaxRate.split('.').length - 1]}`];

    if (priceWrapper) {
      let currencySymbol = "";
      switch(this.deliveryCountryCurrency.toLowerCase()) {
        case 'usd':
          currencySymbol = '$';
          break;

        case 'chf':
          currencySymbol = 'CHF';
          break;

        default:
          currencySymbol = '€';
          break;
      }
      priceWrapper.dataset.currency = currencySymbol;
      priceWrapper.dataset.price = price;
      priceWrapper.dataset.currentPrice = price;
      priceWrapper.textContent = `${priceWrapper.dataset.priceText} ${priceWrapper.dataset.currency} ${price}`;
      if (vatWrapper && priceWrapper.dataset.priceWithoutVatLabel && priceWrapper.dataset.priceWithVatLabel) {
        vatWrapper.textContent = (this.currentTaxRate == '0.00' || this.currentTaxRate == '0') ? `${priceWrapper.dataset.priceWithoutVatLabel}` : `${priceWrapper.dataset.priceWithVatLabel}`;
      }
    }
  }

  bindings() {
    if (this.colors) {
      this.colors.forEach((color) => {
        color.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'touch') return

          this.changeDetails(color);
        });

        color.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'touch') return

          this.resetDetails(color);
        });
      });
    }
  }

  cache() {
    this.colors = this.element.querySelectorAll('.m-product-list-teaser__colors-item');
    this.deliveryCountryInput = document.querySelector('.js-ld-label input[checked]');
    this.currentTaxRateInput = document.querySelector('.js-ls-delivery-country-form input[name="currentTaxRate"]');
    this.deliveryCountryCurrency = this.deliveryCountryInput?.dataset.currency || 'EUR';
    this.currentTaxRate = this.currentTaxRateInput?.value || '0';
    this.variants = JSON.parse(this.element.querySelector('.m-product-list-teaser-variants')?.innerHTML || '[]')
  }

  preloadVariantImages() {
    if (!this.colors?.length) return

    const observer = new IntersectionObserver(([{isIntersecting}]) => {
      if (!isIntersecting) return

      observer.unobserve(this.element)

      this.variants.forEach(variant => {
        const link = document.createElement('link')
        link.setAttribute('rel', 'preload')
        link.setAttribute('as', 'image')
        link.setAttribute('href', variant.image)
        this.element.appendChild(link)
      })

    })

    observer.observe(this.element)
  }

  init() {
    this.cache();
    this.bindings();

    this.initPrice();
    this.preloadVariantImages()
  }
}

export default ProductListTeaser;
